// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-wrapper input[type=text],
.login-wrapper input[type=email],
.login-wrapper input[type=tel],
.login-wrapper select,
.login-wrapper textarea,
.login-wrapper .ant-input-password {
  padding: 0.625rem 0.875rem;
}
.login-wrapper input[type=text] .ant-input-password-icon,
.login-wrapper input[type=email] .ant-input-password-icon,
.login-wrapper input[type=tel] .ant-input-password-icon,
.login-wrapper select .ant-input-password-icon,
.login-wrapper textarea .ant-input-password-icon,
.login-wrapper .ant-input-password .ant-input-password-icon {
  color: #8F9CBB;
}
.login-wrapper input[type=text] input[type=text],
.login-wrapper input[type=email] input[type=text],
.login-wrapper input[type=tel] input[type=text],
.login-wrapper select input[type=text],
.login-wrapper textarea input[type=text],
.login-wrapper .ant-input-password input[type=text] {
  padding: 0;
  height: auto;
  border: 0;
}
.login-wrapper .ant-form input[type=password] {
  padding: 0;
  height: auto;
}
.login-wrapper .form-row {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: #fff;
}
.login-wrapper .login-pic-background {
  background: #fff;
}
.login-wrapper .login-pic {
  height: 100vh;
  width: 100%;
  margin: 0;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #110534;
  background-size: cover;
  border-bottom-left-radius: 200px;
}
.login-wrapper .login-pic img {
  max-width: 70%;
  height: auto;
  z-index: 1;
}
.login-wrapper .login-form-wrapper {
  width: 32.5rem;
  padding: 3.125rem;
  border-radius: 4px;
  margin: 0 1.25rem;
}
.login-wrapper .login-form-wrapper .footerText {
  position: absolute;
  bottom: 20px;
  color: #8F9CBB;
}
.login-wrapper .login-form-wrapper .ant-form-item {
  margin-bottom: 1rem;
}
.login-wrapper .login-form-wrapper .title {
  margin-bottom: 0.875rem;
  font-size: 1.5625rem;
}
.login-wrapper .login-form-wrapper .desc {
  margin-bottom: 1.25rem;
  font-size: 0.75rem;
}
.login-wrapper .login-form-wrapper .form-group .ant-form-item-label label {
  color: #000;
}
.login-wrapper .app-logo {
  width: 100%;
  margin-bottom: 1.5625rem;
}
.login-wrapper .app-logo .sign-in {
  margin: 0;
  font-size: 1.875rem;
  font-weight: bold;
}
.login-wrapper .app-logo .sign-in-text {
  margin: 0;
  color: #8F9CBB;
  font-weight: 100;
}
.login-wrapper .login-form-row {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
}
.login-wrapper .needHelpTxt {
  margin-top: 1.875rem;
  margin-bottom: 0;
  color: #374254;
  font-size: 0.875rem;
}
.login-wrapper .needHelpTxt a {
  margin-left: 0.3125rem;
  color: #7E1F8D;
}
.login-wrapper .forget-password-link {
  color: #000;
  font-size: 1.5rem;
  text-decoration: underline;
}
.login-wrapper .ant-alert {
  width: 100%;
  margin-bottom: 1.25rem !important;
}

@media (max-width: 767px) {
  .login-form-row .form-row {
    margin: 0 1.875rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Authentication/style.scss","webpack://./src/assets/sass/_variables.scss"],"names":[],"mappings":"AAII;;;;;;EAMI,0BAAA;AAHR;AAKQ;;;;;;EACI,cAAA;AAEZ;AACQ;;;;;;EACI,UAAA;EACA,YAAA;EACA,SAAA;AAMZ;AAAQ;EACI,UAAA;EACA,YAAA;AAEZ;AAEI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,gBCtBK;ADsBb;AAGI;EACI,gBC1BK;ADyBb;AAII;EACI,aAAA;EACA,WAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBCpCO;EDsCP,sBAAA;EACA,gCAAA;AAHR;AAKQ;EACI,cAAA;EACA,YAAA;EACA,UAAA;AAHZ;AA6BI;EACI,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;AA3BR;AA6BQ;EACI,kBAAA;EACA,YAAA;EACA,cAAA;AA3BZ;AA8BQ;EACI,mBAAA;AA5BZ;AA+BQ;EACI,uBAAA;EACA,oBAAA;AA7BZ;AAgCQ;EACI,sBAAA;EACA,kBAAA;AA9BZ;AAoCgB;EACI,WCrGP;ADmEb;AAwCI;EACI,WAAA;EACA,wBAAA;AAtCR;AAwCQ;EACI,SAAA;EACA,mBAAA;EAEA,iBAAA;AAvCZ;AA2CQ;EACI,SAAA;EAEA,cAAA;EACA,gBAAA;AA1CZ;AA+CI;EACI,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;AA7CR;AAiDI;EACI,oBAAA;EACA,gBAAA;EACA,cCxIO;EDyIP,mBAAA;AA/CR;AAiDQ;EACI,sBAAA;EACA,cC9IK;AD+FjB;AAmDI;EACI,WCrJK;EDsJL,iBAAA;EACA,0BAAA;AAjDR;AAoDI;EACI,WAAA;EACA,iCAAA;AAlDR;;AAwDA;EAEQ;IACI,kBAAA;EAtDV;AACF","sourcesContent":["@import \"../../assets/sass/variables\";\n\n.login-wrapper {\n\n    input[type=text],\n    input[type=email],\n    input[type=tel],\n    select,\n    textarea,\n    .ant-input-password {\n        padding: rem(10) rem(14);\n\n        .ant-input-password-icon {\n            color: #8F9CBB;\n        }\n\n        input[type=text] {\n            padding: 0;\n            height: auto;\n            border: 0;\n        }\n\n    }\n\n    .ant-form {\n        input[type=password] {\n            padding: 0;\n            height: auto;\n        }\n    }\n\n    .form-row {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        height: 100vh;\n        background: $colorwhite;\n    }\n\n    .login-pic-background {\n        background: $colorwhite;\n    }\n\n    .login-pic {\n        height: 100vh;\n        width: 100%;\n        margin: 0;\n        overflow: hidden;\n        position: relative;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        background-color: $colorprimary;\n        // background: url('../../assets/images/horizon digital.png') center no-repeat;\n        background-size: cover;\n        border-bottom-left-radius: 200px;\n\n        img {\n            max-width: 70%;\n            height: auto;\n            z-index: 1;\n            // max-width: rem(600);\n            // z-index: 1;\n            // height: 100%;\n            // width: 100%;\n            // object-fit: cover;\n            // margin: 0;\n            // object-position: top;\n            // -webkit-transform: scale(1);\n            // transform: scale(1);\n            // -webkit-transform-origin: right 0;\n            // transform-origin: top;\n        }\n\n        // &:before {\n        //     content: '';\n        //     background: $colorblack;\n        //     height: 100%;\n        //     width: 100%;\n        //     position: absolute;\n        //     top: 0;\n        //     left: 0;\n        //     opacity: 0.7;\n        // }\n    }\n\n    .login-form-wrapper {\n        width: rem(520);\n        padding: rem(50);\n        border-radius: 4px;\n        margin: 0 rem(20);\n\n        .footerText {\n            position: absolute;\n            bottom: 20px;\n            color: #8F9CBB;\n        }\n\n        .ant-form-item {\n            margin-bottom: rem(16);\n        }\n\n        .title {\n            margin-bottom: rem(14);\n            font-size: rem(25);\n        }\n\n        .desc {\n            margin-bottom: rem(20);\n            font-size: rem(12);\n            // color: $colorcontent;\n        }\n\n        .form-group {\n            .ant-form-item-label {\n                label {\n                    color: $colorblack;\n                }\n            }\n        }\n    }\n\n    .app-logo {\n        width: 100%;\n        margin-bottom: rem(25);\n\n        .sign-in {\n            margin: 0;\n            font-size: rem(30);\n            // color: $colororange;\n            font-weight: bold;\n            // font-family: $font-secondary;\n        }\n\n        .sign-in-text {\n            margin: 0;\n            // font-size: rem(30);\n            color: #8F9CBB;\n            font-weight: 100;\n            // font-family: $font-secondary;\n        }\n    }\n\n    .login-form-row {\n        position: absolute;\n        top: 50%;\n        transform: translateY(-50%);\n        width: 100%;\n    }\n\n\n    .needHelpTxt {\n        margin-top: rem(30);\n        margin-bottom: 0;\n        color: $colorcontent;\n        font-size: rem(14);\n\n        a {\n            margin-left: rem(5);\n            color: $colorsecondary;\n        }\n    }\n\n    .forget-password-link {\n        color: $colorblack;\n        font-size: rem(24);\n        text-decoration: underline;\n    }\n\n    .ant-alert {\n        width: 100%;\n        margin-bottom: rem(20) !important;\n    }\n\n}\n\n\n@media (max-width: 767px) {\n    .login-form-row {\n        .form-row {\n            margin: 0 rem(30);\n        }\n    }\n}","@use \"sass:math\";\n\n$html-font-size: 16px;\n\n@function stripUnit($value) {\n    @return math.div($value, $value * 0 + 1);\n}\n\n@function rem($pxValue) {\n    @return #{math.div(stripUnit($pxValue), stripUnit($html-font-size))}rem;\n}\n\n//Color Vars\n\n$colorwhite: #fff;\n$colorblack: #000;\n$colorprimary: #110534;\n$colorsecondary: #7E1F8D;\n$colorcontent: #374254;\n$border-color: #E2E8F0;\n$field-bg: #eef0f2;\n$heading-color: #32383F;\n$colorred: #f70c0c;\n$themegray: #8898AA;\n$colorprimaryblue: #DD9510;\n$colororange: #f16932;\n$colordarkblue: #1534a3;\n$colorgreyblue: #010747;\n\n//-------------\n$colorBlue: #422AFB;\n$colorBackground: #F3F2F5;\n$colorLightGrey :#8F9CBB;\n$primaryBtnColor: #13037F;\n$greyWhite: #A09BAE;\n\n\n\n// back button color\n$backBtnColor: #E3E9F1;\n\n//Font Family\n$font-secondary: 'Share', cursive;\n\n$colorMidnightBlue: #1A2659;\n$colorCharcoal: #2D3748;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
